import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataBagService } from 'src/app/common/data-bag.service';
import { OrganizationService } from '../../organization.service';

export interface AddressInterface {
	id: number;
	location: {
		id: number;
		name: string;
		parentLocation: {
			id: number;
			name: string;
		};
	};
	kind: number;
	zipCode: string;
	address: string;
}
@Component({
	selector: 'app-organization-address-edit',
	templateUrl: './organization-address-edit.component.html',
	styleUrls: ['./organization-address-edit.component.scss'],
})
export class OrganizationAddressEditComponent implements OnInit {
	addressData = {
		id: null,
		location: {
			id: null,
			name: null,
		},
		kind: null,
		zipCode: null,
		address: null,
	};
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: AddressInterface,
		public bag: DataBagService,
		private readonly dialogRef: MatDialogRef<any>,
		public service: OrganizationService,
	) {}

	ngOnInit(): void {
		this.addressData = this.data;
	}

	editAddress() {
		this.addressData.location = this.service.enterpriseData.locations.find(
			(findLocation) => findLocation.id === this.addressData.location.id,
		);
		this.dialogRef.close(this.addressData);
	}
}
